import React from 'react';
import FaqsPage from "../FaqsPage";

class FaqsPageHashLink extends React.Component {

    render() {
        return (
            <div>
                <FaqsPage activeTab= {4} />
            </div>
        );
    }
}

export default FaqsPageHashLink
